$(function($){
  let width = $(window).width();

  if ($('.branding-wrapper').length > 0) {

    if ($('.demo-branding').length > 0) {
      $('.demo-branding').addClass('branding-desktop-loaded')
    }
    
    if ($('.branding-wrapper').find('div[class$="-desktop-loaded"],div[class*="-desktop-loaded"]').length > 0) {
      $('body').addClass('has-branding');
    }

    let intervalId = setInterval(function(){
      if ($('.branding-wrapper').find('div[class$="-desktop-loaded"],div[class*="-desktop-loaded"]').length > 0) {
        $('body').addClass('has-branding');
        clearInterval(intervalId);
      }
    }, 500);

  }

  // On scroll
  setTimeout(function(){
    onScroll();
    $(document).on('scroll', function() {
      onScroll();
    });
  }, 10);

  function onScroll() {
    let position = $(window).scrollTop();

    // Fixed share buttons
    if ($('.article-socials').length > 0) {
      let startPosition = $('.article-header').offset().top + $('.article-header').height();
      let endPosition = $('.article-text').offset().top + $('.article-text').height();

      if(position > startPosition && 
        position + $(window).height() < endPosition &&
        !$('.article-socials').hasClass('fixed')) {

        $('.article-socials').addClass('fixed');
      }

      if((position < startPosition || 
        position + $(window).height() > endPosition) &&
        $('.article-socials').hasClass('fixed')) {

        $('.article-socials').removeClass('fixed');
      } 

      if(position + $(window).height() > endPosition) {
        $('.article-socials').addClass('hidden-mobile');
      } else {
        $('.article-socials').removeClass('hidden-mobile');
      }

    }

  }

});
